import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { persistor, store } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { LanguageProvider } from "./hooks/LanguageContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode >
    <LanguageProvider>
    <Provider store={store}>
      <PersistGate loading={"loading"} persistor={persistor}>
        <App  />
      </PersistGate>{" "}
    </Provider>{" "}
    </LanguageProvider>
  </React.StrictMode>
);
